import React, { FC } from 'react';
import './ActionCard.scss';
import { Tooltip } from '@appkit4/react-components';

interface ActionCardProps {
    imageSrc: string;
    title: string;
    description: string;
    onClick: () => void;
    disabled?: boolean;
}

const ActionCard: FC<ActionCardProps> = ({
    imageSrc,
    title,
    description,
    onClick,
    disabled,
}) => {
    return (
        <>
            {disabled && (
                <Tooltip
                    target=".action-card-disabled"
                    trigger="hover"
                    position="top-left"
                    id="tooltipDesc"
                    distance={2}
                    content="Contact us to enable this feature."
                ></Tooltip>
            )}
            <div
                className={`action-card${
                    disabled ? ' action-card-disabled' : ''
                }`}
                onClick={disabled ? undefined : onClick}
            >
                <div className="action-card__image">
                    <img src={imageSrc} alt={title} />
                </div>
                <div className="action-card__content">
                    <h3 className="action-card__title">{title}</h3>
                    <p className="action-card__description">{description}</p>
                </div>
            </div>
        </>
    );
};

export default ActionCard;
